import { render, staticRenderFns } from "./ProductGalleryManageNewItemImage.vue?vue&type=template&id=6ac1400e&scoped=true&"
import script from "./ProductGalleryManageNewItemImage.vue?vue&type=script&lang=js&"
export * from "./ProductGalleryManageNewItemImage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ac1400e",
  null
  
)

export default component.exports